<app-uni-page [parent]="this" pageTitle="Inventory: Inventory" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"> </app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="flex justify-between items-center mr-4 my-4 shrink-0">
          <div class="flex items-center">
            <p-checkbox
              [(ngModel)]="isAccountOwned"
              (ngModelChange)="toggleIsAccountOwned()"
              name="isAccountOwnedCb"
              inputId="isAccountOwned"
              [binary]="true"
            ></p-checkbox>
            <label for="isAccountOwned" class="ml-2">Show Account-Owned</label>
          </div>
        </div>
        <app-ag-grid [gridOptions]="idsGridOptions" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <app-ag-grid [gridOptions]="itdGridOptions" [rowData]="itemDetails" class="flex-1 min-h-0"></app-ag-grid>
        <!-- <ng-template #damageCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" *ngIf="canMarkDamaged(row)" (click)="showDamaged(row)">
            Mark Damaged
          </button>
          <button pButton type="button" class="p-button-text p-button-sm" *ngIf="canMarkUndamaged(row)" (click)="markUndamaged(row)"></button>
          <button pButton type="button" class="p-button-text p-button-sm" *ngIf="canViewDamaged(row)" (click)="showDamaged(row)">
            View Damaged
          </button>
        </ng-template> -->
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
